/**
 * UPDATE PROMPT — banner gdy nowy SW czeka w stanie waiting.
 * Klik na „Odśwież" wysyła SKIP_WAITING do SW i reloaduje stronę.
 *
 * Działa razem z public/sw.js (P2-26): nowy SW nie aktywuje się
 * automatycznie, czeka aż frontend pozwoli — dzięki temu user nie dostaje
 * podmianki kodu w trakcie ćwiczeń.
 */

import { useEffect, useState } from 'react'

export function UpdatePrompt() {
  const [waitingReg, setWaitingReg] = useState<ServiceWorkerRegistration | null>(null)

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return

    let mounted = true

    const checkRegistration = async () => {
      const reg = await navigator.serviceWorker.getRegistration()
      if (!reg || !mounted) return

      // Istniejący waiting (np. po przeładowaniu zakładki gdy update już
      // ściągnięty wcześniej)
      if (reg.waiting && navigator.serviceWorker.controller) {
        setWaitingReg(reg)
      }

      // Nowy update wykryty w trakcie sesji
      reg.addEventListener('updatefound', () => {
        const installing = reg.installing
        if (!installing) return
        installing.addEventListener('statechange', () => {
          if (
            installing.state === 'installed' &&
            navigator.serviceWorker.controller &&
            mounted
          ) {
            setWaitingReg(reg)
          }
        })
      })
    }

    checkRegistration()

    // Gdy SW kontrolujący się zmieni (po SKIP_WAITING) — reload
    const onControllerChange = () => {
      window.location.reload()
    }
    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange)

    return () => {
      mounted = false
      navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange)
    }
  }, [])

  const handleReload = () => {
    if (!waitingReg?.waiting) return
    waitingReg.waiting.postMessage({ type: 'SKIP_WAITING' })
    // Reload nastąpi przez listener controllerchange
  }

  if (!waitingReg) return null

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-50"
      role="status"
      aria-live="polite"
    >
      <div className="manuscript-card-elevated p-4">
        <h3 className="font-display text-base text-ink mb-1">Nowa wersja gotowa</h3>
        <p className="font-body text-sm text-ink/70 mb-3">
          Pobrano aktualizację aplikacji. Odśwież żeby zacząć z najnowszą wersją.
        </p>
        <button
          onClick={handleReload}
          className="btn-primary w-full"
        >
          Odśwież teraz
        </button>
      </div>
    </div>
  )
}
